export default __webpack_public_path__ + "static/media/Bhumika.8a1e7ddb.JPG";